const Table = {
  props: [
    {
      name: 'dataSource',
      default: '',
      type: 'Array<Record<string, any>>',
      desc: '本地数据源， 与 loader、paged-loader互斥'
    },
    {
      name: 'loader',
      default: '',
      type: '(params?: Record<string| number, any>): Promise<T[]>',
      desc: '数据加载器， 与 dataSource、paged-loader互斥'
    },
    {
      name: 'paged-loader',
      default: '',
      type: 'PagedDataLoader',
      desc: '数据分页加载器， 与 dataSource、loader互斥'
    },
    {
      name: 'pageable',
      default: 'true',
      type: 'boolean',
      desc: '是否分页'
    },
    {
      name: 'columns',
      default: '',
      type: 'TableColumnDef[]',
      desc: '配置列， 使用配置信息渲染表格列'
    },
    {
      name: 'default-size',
      default: '',
      type: 'number',
      desc: '默认每页条数'
    },
    {
      name: 'row-key',
      default: '',
      type: 'string',
      desc: '数据标识，实现跨页选择该字段必填'
    },
    {
      name: 'type',
      default: '',
      type: 'admin | client',
      desc: '分为管理端与客户端风格'
    },
    {
      name: 'checkedRows',
      default: '',
      type: 'any[]',
      desc: '选择项，可使用 sync 进行双向交互'
    },
    {
      name: 'showSummary',
      default: '',
      type: 'boolean',
      desc: '是否在表尾显示合计行'
    },
    {
      name: 'sumText',
      default: '',
      type: 'string',
      desc: '合计行第一列的文本'
    },
    {
      name: 'summaryMethod',
      default: '',
      type: '(args: { columns: any[]; data: any[] }) => string[]',
      desc: '自定义的合计计算方法'
    },
    {
      name: 'height',
      default: '',
      type: 'string',
      desc: '高度'
    },
    {
      name: 'max-height',
      default: '',
      type: 'string',
      desc: '最大高度'
    }
  ],
  slots: [
    {
      name: 'prop:*',
      value: '{row, column}',
      desc: '配置模式下， 自定义列内容'
    }
  ],
  methods: [
    {
      name: 'query',
      value: '(params: Record<string | number, any> = {}) => void',
      desc: '查询'
    },
    {
      name: 'refresh',
      value: '() => void',
      desc: '刷新'
    }
  ]
}

export default [
  {
    name: 'DataTable API',
    content: Table
  }
]
